import { api } from '../../DefaultService';
import {
  ISigmaAccountsProps,
  ISigmaCreateProps,
  ISigmaProps,
  ISigmaUpdateParams,
} from './types';

const ENDPOINT = '/v1/integrations/sigma';

export const createSigmaIntegrationAsync = async (data: ISigmaCreateProps) => {
  return await api
    .post(`${ENDPOINT}`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getSigmaIntegrationByIdAsync = async (
  id: number,
): Promise<ISigmaProps> => {
  return await api
    .get<ISigmaProps>(`${ENDPOINT}/${id}`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getAllSigmaIntegrationsAsync = async (): Promise<
  ISigmaProps[]
> => {
  return await api
    .get<ISigmaProps[]>(`${ENDPOINT}/getAllByLicense`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getSigmaAccountsAsync = async (
  sigmaToken: string,
): Promise<ISigmaAccountsProps[]> => {
  return await api
    .get<ISigmaAccountsProps[]>(`${ENDPOINT}/accounts`, {
      params: { sigmaToken },
    })
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const updateSigmaIntegrationAsync = async ({
  id,
  data,
}: ISigmaUpdateParams) => {
  return await api
    .put(`${ENDPOINT}/${id}`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const deleteSigmaIntegrationAsync = async (id: number) => {
  return await api.delete(`${ENDPOINT}/${id}`).catch((error) => {
    throw new Error(
      error?.response?.data?.message || 'Erro interno do servidor!',
    );
  });
};
